import { dayKeyInZone } from '@/lib/dayKey';

/** The `YYYY-MM-DD` calendar day of `nowMs` in `zone` (the day-bucketing zone of the page). */
export function todayKeyInZone(nowMs: number, zone: string): string {
  return dayKeyInZone(new Date(nowMs).toISOString(), zone);
}

/**
 * The day the Matches tab opens on. Today when it has matches; otherwise the
 * next match day (before the event: day one; a rest day inside it: the day
 * after); after the event, the last day. `today === null` is the server render
 * and first client render, before the clock is known: day one, which the
 * viewer never sees because the list only renders after its post-mount fetch.
 * `YYYY-MM-DD` strings sort chronologically, so plain comparison is enough.
 */
export function defaultMatchDay(days: string[], today: string | null): string | null {
  if (days.length === 0) return null;
  const sorted = [...days].sort();
  if (today === null) return sorted[0];
  return sorted.find((d) => d >= today) ?? sorted[sorted.length - 1];
}

/**
 * Label for a calendar day. `dayKey` is a day, not an instant: pin it to UTC
 * noon and format in UTC so it reads as that day in every viewer zone.
 */
export function formatDayKey(dayKey: string, locale: string): string {
  return new Date(`${dayKey}T12:00:00Z`).toLocaleDateString(locale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
